import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';

import { GridStickyHeaderDirective } from './grid-sticky.grid.header-directive';

import { GroupingGridExModule } from './Grouping/grouping-ex.module';

import { KendoGridColumnExComponent } from './Column-Extension/column-component-ex.component';
import { KendoGridColumnExBooleanComponent } from './Column-Extension/kendo-grid-column-ex-boolean';
import { UpsGridCodeColumnComponent } from './Column-Extension/grid-code-column.component';

// import { IsBlankFilterOperatorComponent } from './Filtering/Operators/is-blank-operator.component';
// import { IsNotBlankFilterOperatorComponent } from './Filtering/Operators/is-not-blank-operator.component';

import { GridFilter2DigitYearSupportDirective } from './Filtering/grid-filter-2digit-year-support.directive';

import { CollectionFilterDirective } from './Filtering/UX/collection-filter.directive';

import { CheckBoxFilterMenuComponent } from './Filtering/UX/menu/grid-checkbox-filter-menu.component';
import { CheckBoxFilterMenuSignalComponent } from './Filtering/UX/menu/grid-checkbox-filter-menu-signal.component';
import { RynReplayGridSnapshotDirective } from './ryn-replay-grid-snapshot.directive';
import { IfExportAllowedDirective } from '@ups/xplat/web/core';
import { GridExcelButtonComponent } from './grid-excel-button.component';

const _exports = [
  //
  // Grid related
  GridStickyHeaderDirective,

  KendoGridColumnExComponent,
  KendoGridColumnExBooleanComponent,
  UpsGridCodeColumnComponent,

  //
  // Filtering related

  // operators
  // IsBlankFilterOperatorComponent,
  // IsNotBlankFilterOperatorComponent,

  // general
  GridFilter2DigitYearSupportDirective,

  // UX (menu / cell)
  CollectionFilterDirective,

  CheckBoxFilterMenuComponent,
  CheckBoxFilterMenuSignalComponent,
];

const declarations = [..._exports];

@NgModule({
  declarations: [declarations],
  // #34476: export-gating directive + gated Excel button re-exported for grid templates.
  exports: [
    ..._exports,
    RynReplayGridSnapshotDirective,
    IfExportAllowedDirective,
    GridExcelButtonComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropDownsModule,
    GridModule,
    GroupingGridExModule,
    RynReplayGridSnapshotDirective,
    IfExportAllowedDirective,
    GridExcelButtonComponent,
  ],
})
export class GridModuleEx {}
